
{
  "familyId": "SWW-VT-ZULLEN-KUNNEN",
  "questions": [
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-001",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'zullen' in: 'Ik ... morgen komen.'?",
      "options": ["zou", "zal", "zulde", "gezuld"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Hulpwerkwoorden VT", "content": "Zullen, kunnen, willen en mogen zijn onregelmatige hulpwerkwoorden. Zullen → zou/zouden. Kunnen → kon/konden. Willen → wilde/wilden. Mogen → mocht/mochten.", "icon": "lightbulb"}}],
      "conceptId": "vt_zullen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'Zullen' is een onregelmatig hulpwerkwoord. De verleden tijd is: ik zou, wij zouden. Niet 'zulde' — dat bestaat niet.",
        "solutionSteps": ["Zullen is onregelmatig", "Enkelvoud VT: zou", "Meervoud VT: zouden"],
        "distractorExplanations": {
          "0": "Goed! Zullen → zou (enkelvoud).",
          "1": "Je hebt de tegenwoordige tijd geschreven (ik zal). De verleden tijd van zullen is zou. Onthoud: zullen → zou/zouden.",
          "2": "Je dacht waarschijnlijk dat je -de achter de stam zet. Maar 'zullen' is onregelmatig — 'zulde' bestaat niet. Onthoud: zullen → zou.",
          "3": "Je dacht waarschijnlijk aan het voltooid deelwoord. Maar 'gezuld' bestaat niet. Zullen heeft geen normaal VD. Onthoud: zullen → zou (VT)."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.tt-vt-tijd-verward", "label": "Tegenwoordige tijd gebruikt i.p.v. verleden tijd", "optionIndex": 1 },
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord regelmatig vervoegd (zulde)", "optionIndex": 2 },
          { "id": "sww.past-participle-wrong-form", "label": "Niet-bestaand voltooid deelwoord gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-002",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'kunnen' in: 'Zij ... goed zwemmen.'?",
      "options": ["kon", "kan", "kunde", "gekunnen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Kunnen → kon", "content": "Kunnen is onregelmatig. Enkelvoud VT: kon. Meervoud VT: konden.", "icon": "lightbulb"}}],
      "conceptId": "vt_kunnen",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "'Kunnen' is onregelmatig. De verleden tijd is: zij kon (enkelvoud), zij konden (meervoud). Hier is 'zij' enkelvoud, dus: kon.",
        "solutionSteps": ["Kunnen is onregelmatig", "Enkelvoud VT: kon", "Meervoud VT: konden"],
        "distractorExplanations": {
          "0": "Goed! Kunnen → kon (enkelvoud VT).",
          "1": "Je hebt de tegenwoordige tijd geschreven (zij kan). De verleden tijd is kon. Onthoud: kunnen → kon/konden.",
          "2": "Je dacht waarschijnlijk dat je -de achter de stam zet. Maar 'kunde' bestaat niet als werkwoordsvorm. Onthoud: kunnen → kon.",
          "3": "Je dacht aan het voltooid deelwoord. Maar de vraag vraagt naar de verleden tijd. Kunnen → kon (VT), gekund (VD). Onthoud: VT ≠ VD."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.tt-vt-tijd-verward", "label": "Tegenwoordige tijd gebruikt i.p.v. verleden tijd", "optionIndex": 1 },
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord regelmatig vervoegd (kunde)", "optionIndex": 2 },
          { "id": "sww.vt-vd-verward", "label": "Voltooid deelwoord i.p.v. verleden tijd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-003",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct?",
      "options": ["Wij zouden graag meedoen.", "Wij zouwen graag meedoen.", "Wij zulden graag meedoen.", "Wij zou graag meedoen."],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Meervoud van zou", "content": "Enkelvoud: ik/jij/hij zou. Meervoud: wij/jullie/zij zouden. Niet 'zouwen' of 'zulden'.", "icon": "lightbulb"}}],
      "conceptId": "vt_zullen_meervoud",
      "variantIndex": 3,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "'Zullen' is een onregelmatig hulpwerkwoord. De verleden tijd is: ik/jij/hij zou (enkelvoud), wij/jullie/zij zouden (meervoud). 'Wij' is meervoud, dus je schrijft 'zouden'. Vormen als 'zouwen' of 'zulden' bestaan niet — je moet deze vormen uit je hoofd leren.",
        "solutionSteps": ["Wij = meervoud", "Zou (enkelvoud) → zouden (meervoud)", "Wij zouden graag meedoen"],
        "distractorExplanations": {
          "0": "Goed! Wij zouden is de correcte meervoudsvorm.",
          "1": "Je dacht waarschijnlijk dat het meervoud 'zouwen' is. Maar dat bestaat niet. Het meervoud van zou is zouden. Onthoud: zou → zouden.",
          "2": "Je dacht waarschijnlijk dat je -den achter 'zul' zet. Maar 'zulden' bestaat niet. De VT van zullen is zou/zouden. Onthoud: zullen → zou/zouden.",
          "3": "Je hebt de enkelvoudsvorm gebruikt bij een meervoudsonderwerp. 'Wij' is meervoud, dus je schrijft 'zouden', niet 'zou'. Onthoud: wij/jullie/zij → zouden."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.irregular-plural-invented", "label": "Niet-bestaande meervoudsvorm gemaakt (zouwen)", "optionIndex": 1 },
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord regelmatig vervoegd (zulden)", "optionIndex": 2 },
          { "id": "sww.vt-enkelvoud-bij-meervoud", "label": "Enkelvoud gebruikt bij meervoud onderwerp", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-004",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "multiple_choice",
      "question": "Wat is de verleden tijd van 'mogen' in: 'Hij ... niet meedoen.'?",
      "options": ["mocht", "mag", "mogde", "gemogen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Mogen → mocht", "content": "Mogen is onregelmatig. Enkelvoud VT: mocht. Meervoud VT: mochten.", "icon": "lightbulb"}}],
      "conceptId": "vt_mogen",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Mogen' is onregelmatig. De verleden tijd is: hij mocht (enkelvoud), zij mochten (meervoud).",
        "solutionSteps": ["Mogen is onregelmatig", "Enkelvoud VT: mocht", "Meervoud VT: mochten"],
        "distractorExplanations": {
          "0": "Goed! Mogen → mocht.",
          "1": "Je hebt de tegenwoordige tijd geschreven (hij mag). De verleden tijd is mocht. Onthoud: mogen → mocht/mochten.",
          "2": "Je dacht waarschijnlijk dat je -de achter de stam zet. Maar 'mogde' bestaat niet. Onthoud: mogen → mocht.",
          "3": "Je dacht aan het voltooid deelwoord. Maar de vraag vraagt naar de verleden tijd. Onthoud: VT van mogen = mocht."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.tt-vt-tijd-verward", "label": "Tegenwoordige tijd gebruikt i.p.v. verleden tijd", "optionIndex": 1 },
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord regelmatig vervoegd (mogde)", "optionIndex": 2 },
          { "id": "sww.vt-vd-verward", "label": "Voltooid deelwoord i.p.v. verleden tijd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-005",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "fill_in",
      "question": "Vul de verleden tijd in: De kinderen ... (willen) graag een ijsje.",
      "options": [],
      "correctAnswer": "wilden",
      "data": {
        "acceptedAnswers": ["wilden"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Willen → wilde/wilden", "content": "Willen is onregelmatig. Enkelvoud VT: wilde. Meervoud VT: wilden. 'De kinderen' = meervoud → wilden.", "icon": "lightbulb"}}],
      "conceptId": "vt_willen_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "'Willen' is een onregelmatig hulpwerkwoord. De verleden tijd is: ik/hij wilde (enkelvoud), wij/zij wilden (meervoud). 'De kinderen' is meervoud, dus je schrijft 'wilden'. Onthoud: willen → wilde/wilden.",
        "solutionSteps": ["De kinderen = meervoud", "Willen → wilde (enkelvoud), wilden (meervoud)", "Antwoord: wilden"]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Mogelijke fout: 'wilde' i.p.v. 'wilden' (enkelvoud i.p.v. meervoud)" }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-006",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "fill_in",
      "question": "Vul in: Vorig jaar ... (kunnen) zij goed zwemmen.",
      "correctAnswer": "kon",
      "data": {
        "acceptedAnswers": ["kon"],
        "placeholder": "verleden tijd van kunnen",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Kunnen in de VT", "content": "Kunnen → kon (enkelvoud) / konden (meervoud). 'Zij' is hier enkelvoud → kon.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_kunnen_fill_in",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "'Vorig jaar' = verleden tijd. 'Zij' is hier enkelvoud. Kunnen → kon (enkelvoud VT). Dus: 'Vorig jaar kon zij goed zwemmen.'",
        "solutionSteps": [
          "Signaalwoord: 'vorig jaar' → verleden tijd",
          "Onderwerp: 'zij' → enkelvoud",
          "Kunnen → kon (enkelvoud VT)"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.tt-vt-tijd-verward", "label": "Mogelijke fout: 'kan' (tegenwoordige tijd)" },
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Mogelijke fout: 'kunde' (regelmatig vervoegd)" }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-007",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "matching",
      "question": "Koppel elk hulpwerkwoord aan de juiste verleden tijd (enkelvoud).",
      "correctAnswer": null,
      "data": {
        "pairs": [
          { "left": "zullen", "right": "zou" },
          { "left": "kunnen", "right": "kon" },
          { "left": "willen", "right": "wilde" },
          { "left": "mogen", "right": "mocht" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Hulpwerkwoorden VT", "content": "Zullen → zou/zouden. Kunnen → kon/konden. Willen → wilde/wilden. Mogen → mocht/mochten. Dit zijn onregelmatige werkwoorden — je moet ze uit je hoofd leren.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_hulpww_matching",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De verleden tijd van deze hulpwerkwoorden is onregelmatig: zullen → zou, kunnen → kon, willen → wilde, mogen → mocht. Deze vormen moet je uit je hoofd kennen.",
        "solutionSteps": [
          "Zullen → zou (niet zulde)",
          "Kunnen → kon (niet kunde)",
          "Willen → wilde (niet wilte)",
          "Mogen → mocht (niet mogde)"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatige vormen verwisselen of regelmatig maken" }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-008",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "error_spotting",
      "question": "Vind de fouten in de verleden tijd van de onregelmatige hulpwerkwoorden.",
      "correctAnswer": 0,
      "data": {
        "text": "Hij zulde niet helpen toen we het vroegen. Ik wilte vorige week een nieuw boek kopen.",
        "errors": [
          { "word": "zulde", "position": 1, "correction": "zou", "explanation": "Zullen is onregelmatig. Verleden tijd enkelvoud: zou (niet zulde, die vorm bestaat niet)." },
          { "word": "wilte", "position": 9, "correction": "wilde", "explanation": "Willen is onregelmatig. Verleden tijd enkelvoud: wilde (niet wilte, die vorm bestaat niet)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Onregelmatige hulpwerkwoorden", "content": "Zullen wordt zou/zouden. Kunnen wordt kon/konden. Willen wordt wilde/wilden. Mogen wordt mocht/mochten. Vormen als zulde, wilte, kunde bestaan niet, je moet de juiste vormen uit je hoofd leren.", "icon": "lightbulb" } }
      ],
      "conceptId": "vt_hulpww_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Twee fouten met onregelmatige hulpwerkwoorden. 'Zulde' bestaat niet, zullen wordt zou. 'Wilte' bestaat niet, willen wordt wilde. Bij hulpwerkwoorden zoals zullen, kunnen, willen en mogen werkt de kofschip-regel niet: deze hebben unieke verleden-tijdvormen die je moet kennen.",
        "solutionSteps": [
          "Identificeer het hulpwerkwoord",
          "Geen kofschip toepassen, vorm is onregelmatig",
          "Zou, kon, wilde, mocht zijn de enige correcte vormen",
          "Vergelijk met de geschreven vorm"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Onregelmatig werkwoord regelmatig vervoegd (zulde, wilte)" }
        ]
      }
    },
    {
      "id": "SWW-VT-ZULLEN-KUNNEN-009",
      "familyId": "SWW-VT-ZULLEN-KUNNEN",
      "module": "SpellingWW",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "verleden_tijd",
      "subSkill": "vt_hulpwerkwoorden",
      "questionType": "categorize",
      "question": "Sorteer elke vorm: is het een correcte verleden tijd of bestaat de vorm niet?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Correcte verleden tijd", "Bestaat niet"],
        "items": [
          { "text": "zou (zullen)", "correctCategory": 0 },
          { "text": "kon (kunnen)", "correctCategory": 0 },
          { "text": "wilde (willen)", "correctCategory": 0 },
          { "text": "mocht (mogen)", "correctCategory": 0 },
          { "text": "zouden (zullen)", "correctCategory": 0 },
          { "text": "zulde (zullen)", "correctCategory": 1 },
          { "text": "kunde (kunnen)", "correctCategory": 1 },
          { "text": "wilte (willen)", "correctCategory": 1 },
          { "text": "mogde (mogen)", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onregelmatige werkwoorden",
            "content": "Deze 4 hulpwerkwoorden hebben unieke verleden-tijdvormen die je uit je hoofd moet leren. Vormen op -de/-te die regelmatig lijken (zulde, kunde, wilte, mogde) bestaan niet.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vt_hulpww_categorize",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Correct: zou, kon, wilde, mocht, zouden — de unieke onregelmatige vormen. Bestaat niet: zulde, kunde, wilte, mogde — regelmatige uitgangen op een onregelmatige stam.",
        "solutionSteps": [
          "Lees de vorm",
          "Vergelijk met de officiële onregelmatige verleden tijd",
          "Match? → correct. Lijkt regelmatig? → bestaat niet"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.onregelmatig-als-regelmatig", "label": "Niet-bestaande regelmatige vorm aangezien voor correct" }
        ]
      }
    }
  ]
}

